import useMainNavigationFadeTransition from "components/MainNavigation/hooks/useFadeTransition";
import useMainNavigationStore from "components/MainNavigation/stores/useMainNavigationStore";
import { selectNavigationIsExpanded } from "components/MainNavigation/selectors/navigationState";
import { MainNavigationItem } from "components/MainNavigation/types";
import { TooltipModalReferenceProps } from "ds/components/TooltipModal/types";

import MainNavigationGroupItem, { MainNavigationGroupItemProps } from "./GroupItem";
import MainNavigationMenuItem from "./MenuItem";

type MainNavigationNavigationItemProps = {
  item: MainNavigationItem;
  emptyState?: MainNavigationGroupItemProps["emptyState"];
  tooltipModalRef?: TooltipModalReferenceProps["ref"];
};

const MainNavigationNavigationItem = ({
  item,
  emptyState,
  tooltipModalRef,
}: MainNavigationNavigationItemProps) => {
  const isSidebarExpanded = useMainNavigationStore(selectNavigationIsExpanded);
  const { transitionClasses, onTransitionEnd } =
    useMainNavigationFadeTransition(!!isSidebarExpanded);

  if ("items" in item) {
    return (
      <MainNavigationGroupItem
        group={item}
        transitionClasses={transitionClasses}
        onTransitionEnd={onTransitionEnd}
        emptyState={emptyState}
        tooltipModalRef={tooltipModalRef}
      />
    );
  }

  return (
    <MainNavigationMenuItem
      item={item}
      transitionClasses={transitionClasses}
      onTransitionEnd={onTransitionEnd}
    />
  );
};

export default MainNavigationNavigationItem;
